import React from "react";

const TabPanel = (props) => {
return <div id={props.tabId}>
        {props.children}
    </div>;
}

export { TabPanel };